// extracted by mini-css-extract-plugin
export default {"historicalWrapper":"styles_historicalWrapper__ycaga","cycleBtn":"styles_cycleBtn__f7pVY","cycleBtnActive":"styles_cycleBtnActive__1JsTt"};